'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _merge = require('transmute/merge');

var _merge2 = _interopRequireDefault(_merge);

var _update = require('transmute/update');

var _update2 = _interopRequireDefault(_update);

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _getters = require('conversations-async-data/async-data/operators/getters');

var _updateAsyncData = require('conversations-async-data/async-data/operators/updateAsyncData');

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestSucceeded = require('conversations-async-data/async-data/operators/requestSucceeded');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _requestFailed = require('conversations-async-data/async-data/operators/requestFailed');

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _isCloseThreadMessage = require('conversations-schema/pubnub-message/operators/isCloseThreadMessage');

var _isOpenThreadMessage = require('conversations-schema/pubnub-message/operators/isOpenThreadMessage');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _threadSetters = require('conversations-schema/thread/operators/threadSetters');

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _ChatFilterOptions2 = _interopRequireDefault(_ChatFilterOptions);

var _setters = require('conversations-schema/operators/conversation/setters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _setLatestMessage = require('conversations-schema/thread/operators/setLatestMessage');

var _setAssignedAgentFromV2Message = require('conversations-schema/thread/operators/setAssignedAgentFromV2Message');

var _isAssignmentV = require('conversations-schema/pubnub-message/operators/isAssignmentV2');

var _isEmailCaptureResponseMessage = require('conversations-schema/pubnub-message/operators/isEmailCaptureResponseMessage');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

var _isPersistedThread = require('../../threads/operators/isPersistedThread');

var _stubbedThreadId = require('../constants/stubbedThreadId');

var _actionTypes = require('../constants/actionTypes');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var _StubbedThreadHistoryActionTypes = require('../../stubbed-thread-history/constants/StubbedThreadHistoryActionTypes');

var _setCurrentUrl = require('../operators/setCurrentUrl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PUBLISH_MESSAGE = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.PUBLISH_MESSAGE);

var initialState = (0, _AsyncData2.default)({ data: (0, _immutable.Map)() });

var threadsReducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_VisitorActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL, _VisitorActionTypes.ADD_CONVERSATION), function (state, action) {
  var conversation = action.payload.conversation;


  var threadId = (0, _isPersistedThread.isPersistedThread)(conversation) ? (0, _threadGetters.getThreadId)(conversation) : _stubbedThreadId.STUBBED_THREAD_ID;

  return (0, _updateAsyncData.updateAsyncData)((0, _set2.default)(threadId, conversation), state);
}), _defineProperty(_handleActions, _actionTypes.SET_THREADS_SUCCESS, function (state) {
  return (0, _requestSucceeded.requestSucceeded)(state);
}), _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.STAGE_MESSAGE_ON_STUBBED_THREAD, function (state, action) {
  var message = action.payload.message;


  return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(_stubbedThreadId.STUBBED_THREAD_ID, (0, _ifThen2.default)((0, _both2.default)(function () {
    return (0, _messageTypeComparators.isConversationalMessage)(message);
  }, function () {
    return !(0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(message);
  }), (0, _setLatestMessage.setLatestMessage)(message))), state);
}), _defineProperty(_handleActions, _VisitorActionTypes.LAST_SEEN_SUCCESS, function (state, action) {
  var _action$payload = action.payload,
      threadId = _action$payload.threadId,
      latestMessageTimestamp = _action$payload.latestMessageTimestamp;

  var data = (0, _getters.getData)(state);
  var existingThread = (0, _get2.default)(threadId, data);

  if (!existingThread || !latestMessageTimestamp) {
    return state;
  }

  return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _setters.setLatestReadTimestamp)(latestMessageTimestamp)), state);
}), _defineProperty(_handleActions, PUBLISH_MESSAGE.SUCCEEDED, function (state, action) {
  var _action$payload2 = action.payload,
      threadId = _action$payload2.threadId,
      publishedMessage = _action$payload2.publishedMessage;


  return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _ifThen2.default)((0, _both2.default)(function () {
    return (0, _messageTypeComparators.isConversationalMessage)(publishedMessage);
  }, function () {
    return !(0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(publishedMessage);
  }), (0, _setLatestMessage.setLatestMessage)(publishedMessage))), state);
}), _defineProperty(_handleActions, _VisitorActionTypes.RECEIVED_INCOMING_MESSAGE, function (state, action) {
  var _action$payload3 = action.payload,
      threadId = _action$payload3.threadId,
      message = _action$payload3.message;


  var newState = (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _ifThen2.default)((0, _both2.default)(function () {
    return (0, _messageTypeComparators.isConversationalMessage)(message);
  }, function () {
    return !(0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(message);
  }), (0, _setLatestMessage.setLatestMessage)(message))), state);

  if ((0, _isAssignmentV.isAssignmentV2)(message)) {
    return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _setAssignedAgentFromV2Message.setAssignedAgentFromV2Message)(message)), newState);
  }

  if ((0, _isCloseThreadMessage.isCloseThreadMessage)(message)) {
    return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _threadSetters.setStatus)(_ChatFilterOptions2.default.ENDED)), newState);
  }

  if ((0, _isOpenThreadMessage.isOpenThreadMessage)(message)) {
    return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _threadSetters.setStatus)(_ChatFilterOptions2.default.STARTED)), newState);
  }

  return newState;
}), _defineProperty(_handleActions, _VisitorActionTypes.INCREMENT_UNSEEN_COUNT, function (state, action) {
  var threadId = action.payload.threadId;


  return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _update2.default)('unseenCount', function (unseenCount) {
    return unseenCount + 1;
  })), state);
}), _defineProperty(_handleActions, _VisitorActionTypes.CLEAR_UNSEEN_COUNT_FOR_CHANNEL, function (state, action) {
  var threadId = action.payload.threadId;


  return (0, _updateAsyncData.updateAsyncData)((0, _update2.default)(threadId, (0, _set2.default)('unseenCount', 0)), state);
}), _defineProperty(_handleActions, _VisitorActionTypes.GET_VISITOR_THREADS_STARTED, function (state) {
  return (0, _requestStarted.requestStarted)(state);
}), _defineProperty(_handleActions, _VisitorActionTypes.GET_VISITOR_THREADS_SUCCESS, function (state, action) {
  var threads = action.payload.threads;


  var newThreads = !threads || !threads.length ? (0, _immutable.Map)() : threads.reduce(function (newThreadsMap, newThread) {
    var threadId = (0, _threadGetters.getThreadId)(newThread);

    return newThreadsMap.set(threadId, newThread);
  }, (0, _immutable.Map)());

  return (0, _requestSucceededWithOperator.requestSucceededWithOperator)((0, _merge2.default)(newThreads), state);
}), _defineProperty(_handleActions, _VisitorActionTypes.GET_VISITOR_THREADS_FAILURE, function (state) {
  return (0, _requestFailed.requestFailed)(state);
}), _defineProperty(_handleActions, _VisitorActionTypes.CREATE_VISITOR_THREAD_SUCCESS, function (state, action) {
  var _action$payload4 = action.payload,
      thread = _action$payload4.thread,
      threadId = _action$payload4.threadId;


  return (0, _updateAsyncData.updateAsyncData)((0, _set2.default)(threadId, thread), state);
}), _defineProperty(_handleActions, _actionTypes.UPDATE_THREAD_CURRENT_URL, function (state, action) {
  var _action$payload5 = action.payload,
      threadId = _action$payload5.threadId,
      currentUrl = _action$payload5.currentUrl;


  return (0, _updateAsyncData.updateAsyncData)(function (threads) {
    return threads.update(threadId, (0, _setCurrentUrl.setCurrentUrl)(currentUrl));
  }, state);
}), _handleActions), initialState);

var safeReducer = function safeReducer(reducer) {
  return function (state, action) {
    try {
      return reducer(state, action);
    } catch (e) {
      window.Raven.captureMessage('THREADS_REDUCER_ERROR', {
        extra: { error: e, state: state.toJS(), action: action }
      });
      return state;
    }
  };
};

exports.default = safeReducer(threadsReducer);
module.exports = exports['default'];